var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGeography(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H20V20H0Z",
    fill: "none",
    opacity: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98,6.763H1.03C.046,6.763-.3,6.1.28,5.3L3.755.437a.862.862,0,0,1,1.5,0L8.73,5.3C9.3,6.1,8.963,6.763,7.98,6.763Z",
    transform: "translate(5.495 1.621)",
    fill: "#8963f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.688,6.617H1.372C.055,6.617-.4,5.742.38,4.675L3.7,0h4.65L11.68,4.675C12.455,5.742,12,6.617,10.688,6.617Z",
    transform: "translate(3.97 8.383)",
    fill: "#8963f0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25,0V3.333a.63.63,0,0,1-.625.625A.63.63,0,0,1,0,3.333V0Z",
    transform: "translate(9.375 15)",
    fill: "#8963f0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGeography);
export default __webpack_public_path__ + "static/media/icon-geography.3cc42b36dbd62f477c47b4688b1cfd0c.svg";
export { ForwardRef as ReactComponent };